import {
    Dialog,
    DialogContent,
    Button,
    IconButton,
    Typography,
    AppBar,
    Stack,
    Box,
    MenuItem,
    Select,
    Autocomplete,
    TextField,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'
import { useFormikContext } from "formik";
import { CustomTitle } from "../HelperFunctions/HelperFunctions";
import { Loader } from "../HelperFunctions/HelperFunctions";
import { useState } from "react";

import { TimePicker } from 'rsuite';
import "rsuite/dist/rsuite.min.css";
import { enqueueSnackbar } from "notistack";
import { useLoaderData } from "react-router-dom";



const FrequencyDialog = ({ open, onClose }) => {

    const { UID, token } = useLoaderData();
    const { values, handleChange, handleSubmit, setFieldValue } = useFormikContext();

    const [loading, setLoading] = useState(false);

    const generateOptions = () => [
        "End of the Month",
        "---Following Month---",
        ...Array.from({ length: 31 }, (_, i) => `${i + 1}${["st", "nd", "rd"][((i + 1) % 10) - 1] || "th"}`)
    ];

    const frequencyOptions = [
        {
            heading: "Mailing Frequency",
            value: values.frequency.mail_frequency,
            name: "frequency.mail_frequency",
            label: [
                "daily",
                // "weekly",
                // "semi_monthly",
                // "monthly",
                // "quarterly",
                // "half_yearly",
                // "yearly"
            ]
        },
        {
            heading: "Day",
            value: values.frequency.day,
            name: "frequency.day",
            label: generateOptions()

        },
        {
            heading: "Time",
            // value: values.frequency.time,
            // name: "frequency.time",
            // label: [
            // ]
        },
        {
            heading: "Time Zone",
            value: values.frequency.time_zone,
            name: "frequency.time_zone",
            label: [
                "EST",
                "CST",
                "MST",
                "IST"
            ]
        }
    ];

    const handleSaveAndNext = async () => {
        if (values.frequency.time_zone == "" || values.frequency.time === "" || values.frequency.time === null) {
            enqueueSnackbar("Time and time zone must be selected to create the schedule", { variant: "warning" })
            setLoading(false)
            return;
        }
        onClose()
        handleSubmit()
        // setLoading(true)
    };

    const handleTimeChange = (time) => {
        const formattedTime = time ? time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : null;
        handleChange({
            target: {
                name: 'frequency.time',
                value: formattedTime,
            }
        });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) {
            return null;
        }

        const [hours, minutes] = timeStr.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(0);
        return date;
    };

    return (
        <Dialog
            open={open}
            // fullWidth
            sx={{ "& .MuiDialog-paper": { minWidth: "35%", minHeight: "40%", top: 10, position: "fixed" } }}
            BackdropProps={{
                // sx: { backgroundColor: "transparent" },

            }}
            PaperProps={{
                elevation: 0,
                sx: { border: "1px solid rgba(0, 0, 0, 0.12)" }
            }}
        >
            <AppBar sx={{ position: 'relative', bgcolor: "#d7d7d7", height: 45 }} elevation={0} >
                <Box sx={{ height: 45, alignContent: "center", padding: "0 8px" }} >
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                        <Stack direction={"row"}>
                            <IconButton
                                size="small"
                                edge="start"
                                color="inherit"
                                onClick={onClose}
                                // onClick={() => {
                                //     setSlide(1)
                                //     // resetForm();
                                //     onClose();

                                // }}
                                aria-label="close"
                                style={{ backgroundColor: "#686868" }}
                                disableRipple
                            >
                                <CloseIcon sx={{ fontSize: "15px" }} />
                            </IconButton>
                            <Typography
                                sx={{
                                    ml: 2,
                                    flexGrow: 10,
                                    color: "#1f1f1f",
                                }}
                                component="div"
                                fontWeight={600}
                                fontSize={"16px"}

                            >
                                Schedule
                            </Typography>
                        </Stack>
                        <Stack direction={"row"} gap={1}>
                            {/* <Button
                                variant="contained"
                                size='small'
                                disableElevation
                                disableRipple

                                sx={{
                                    px: 4,
                                    textTransform: "none",
                                    backgroundColor: "#b5dcf2",
                                    color: "#000",
                                    fontWeight: 400
                                }}
                                onClick={onClose}
                            >
                                Skip
                            </Button> */}

                            <Button
                                variant="contained"
                                size='small'
                                disableElevation
                                disableRipple

                                sx={{
                                    // px: 3,
                                    textTransform: "none",
                                    backgroundColor: "#b5dcf2",
                                    color: "#000",
                                    fontWeight: 400,
                                }}
                                // onClick={handleSubmit}
                                onClick={handleSaveAndNext}
                            >
                                Save & Finish
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </AppBar>
            <DialogContent>
                <Stack p={2} gap={2} width={"450px"}>

                    {
                        frequencyOptions.map((option, index) => {
                            if (option.heading === "Day" && values.frequency.mail_frequency === "daily") {
                                values.frequency.day = "";
                                return null;
                            }
                            return (
                                <Stack key={index} direction="row" gap={15} justifyContent="space-between">
                                    <Typography sx={{ fontSize: "13px" }}>
                                        {option.heading}
                                    </Typography>
                                    {option.heading === "Time" ? (
                                        <TimePicker
                                            format="HH:mm"
                                            size="sm"
                                            style={{ width: 170 }}
                                            menuStyle={{
                                                zIndex: 1300,
                                                // maxHeight: '250px',
                                                overflowY: 'auto',
                                            }}
                                            value={formatTime(values.frequency.time)}
                                            onChange={handleTimeChange}
                                            hideMinutes={(minute) => minute % 10 !== 0}
                                            editable={false}
                                            ranges={[]}
                                        />
                                    ) : (
                                        <Autocomplete
                                            size="small"
                                            options={option.label}
                                            value={option.value || null}
                                            disableClearable
                                            onChange={(event, newValue) =>
                                                handleChange({
                                                    target: {
                                                        name: option.name,
                                                        value: newValue
                                                    }
                                                })
                                            }
                                            open={option.value === "daily" ? false : undefined}
                                            disabled={option.value === "daily"}
                                            getOptionLabel={(label) => CustomTitle(label)}
                                            isOptionEqualToValue={(option, value) => option === value}
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        fontSize: '13px'
                                                    }
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name={option.name}
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: {
                                                            height: '25px',
                                                            fontSize: '11px',
                                                            padding: '0px 8px'
                                                        }
                                                    }}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: true,
                                                        style: {
                                                            fontSize: '14px',
                                                            padding: 0,
                                                            height: '25px',
                                                            lineHeight: '25px'
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        sx: { fontSize: "2px" },
                                                    }}
                                                    style={{
                                                        width: '170px'
                                                    }}
                                                />
                                            )}

                                        />

                                    )}


                                </Stack>
                            )
                        })
                    }

                </Stack>
                <Loader loading={loading} />
            </DialogContent>
        </Dialog>
    );
};

export default FrequencyDialog;